import clsx from "clsx";
import useAllProjects from "../../../../../hooks/UseAllProjects";
import "./ProjectManager.scss";

export default function ProjectManager({
  onGoToProjectDetailClick,
  onClickPlay,
}: {
  onGoToProjectDetailClick: (projectId: string) => void;
  onClickPlay: () => void;
}) {
  const { data: projects = [], addProject } = useAllProjects();

  return (
    <>
      <div className={clsx("header-row")}>PROJECTS</div>
      <div className={clsx("projects-container")}>
        <div
          className={clsx("project-card", "add-card")}
          title="Add new project"
          onClick={() => {
            addProject((id: string) => {
              onGoToProjectDetailClick(id);
            });
          }}
        >
          ADD NEW PROJECT
        </div>

        {projects.map((project) => (
          <div className={clsx("project-card")} key={project.id}>
            <div
              onClick={() => {
                onGoToProjectDetailClick(project.id);
              }}
              title={`Edit ${project.name}`}
              className={clsx("project-card-edit")}
            >
              <img
                src="ui/gear.svg"
                className={clsx("project-card-edit-icon")}
              />
            </div>
            <div className={clsx("project-card-name")}>{project.name}</div>
            <div className={clsx("project-card-action-row")}>
              <div className={clsx("project-card-play")}>PLAY</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
